import LocalStorage from "./LocalStorage";
// Additional stores here, will need to implement the same
// set of functions LocalStorage exports

// Store to use when no store map is set for the key
let defaultStore: any = LocalStorage;
// key => store map so specific keys can be mapped to diffent stores
// ex: {
//      "KEY_THAT_USES_LOCAL_STORAGE" => LocalStorage,
//      "KEY_THAT_USES_ANOTHER_STORE" => AnotherStore
//    }
let storeMap: Record<string, any> = {};

function getStore(key: string) {
  if (storeMap[key]) {
    return storeMap[key];
  } else {
    return defaultStore;
  }
}

function setDefaultStore(store: any) {
  defaultStore = store;
}

function setStoreMap(map: any) {
  storeMap = map;
}

function getItem(key: string, defaultValue: any) {
  return getStore(key).getItem(key, defaultValue);
}

function setItem(key: string, value: any) {
  getStore(key).setItem(key, value);
}

function removeItem(key: string) {
  getStore(key).removeItem(key);
}

function mergeWithExisting(
  key: string,
  path: string,
  value: any,
  defaultValue: any
) {
  return getStore(key).mergeWithExisting(key, path, value, defaultValue);
}

export default {
  setStoreMap,
  setDefaultStore,
  getItem,
  setItem,
  removeItem,
  mergeWithExisting
};
